module.exports = __webpack_public_path__ + "images/baseball1-dc69ccd5cf380aa834cb2e52c70a1c4e.jpg";